(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  const firstSectionImage = document.querySelector('.main-content > .shopify-section img');
  if (firstSectionImage) {
    firstSectionImage.setAttribute('loading', 'eager');
    firstSectionImage.setAttribute('fetchpriority', 'high');
  }


const mediaQuery = window.matchMedia('(max-width: 749px)');
const elements = document.querySelectorAll('.accordionElement');

function syncFooterAccordion(element) {
  const button = element.querySelector('.accordionHeading button');
  const content = element.querySelector('.accordionContent');
  if (!button || !content) return;

  if (!mediaQuery.matches) {
    button.setAttribute('aria-expanded', 'true');
    content.removeAttribute('inert');
    return;
  }

  const expanded = content.classList.contains('showContent');
  button.setAttribute('aria-expanded', expanded ? 'true' : 'false');
  content.toggleAttribute('inert', !expanded);
}

elements.forEach((element) => {
  const button = element.querySelector('.accordionHeading button');
  const icon = element.querySelector('.accordionHeading button i');
  const content = element.querySelector('.accordionContent');
  if (!button || !icon || !content) return;

  button.addEventListener('click', () => {
    content.classList.toggle('showContent');
    icon.className = content.classList.contains('showContent') ? 'minus-icon' : 'plus-icon';
    syncFooterAccordion(element);
  });

  syncFooterAccordion(element);
});

mediaQuery.addEventListener('change', () => {
  elements.forEach(syncFooterAccordion);
});
  

  } catch(e) { console.error(e); }
})();
})();
